module.exports = __webpack_public_path__ + "static/media/action-a.41c5afa1.jpg";